// extracted by mini-css-extract-plugin
export default {"image":"ClosedLectionImage_image__2yxxf","icon":"ClosedLectionImage_icon__Pl6gf"};